import { typeof as _typeof, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Collapse } from 'react-bootstrap';
import { i18n } from '../../i18n/translate.js';
import { ChakraUIProvider } from '../../react-on-rails/ChakraUIProvider.js';
import { FAIcon } from '../fa-icon/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var _excluded = ["className"];

var createMenuToggle = function createMenuToggle(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: "custom-burger navbar-toggle collapsed ".concat(className)
  }, props), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.t('Toggle navigation')), /*#__PURE__*/React.createElement("i", {
    className: "fa fa-bars"
  }));
};

createMenuToggle.displayName = "createMenuToggle";

var createLearnerHeader = function createLearnerHeader(_ref2) {
  var _navbarRef$current;

  var content = _ref2.content,
      currentUrl = _ref2.currentUrl,
      getFoundryClass = _ref2.getFoundryClass,
      hasColors = _ref2.hasColors,
      isDashiFi = _ref2.isDashiFi,
      isImpersonating = _ref2.isImpersonating,
      isLearner = _ref2.isLearner,
      isMobile = _ref2.isMobile,
      isMobileMenuOpen = _ref2.isMobileMenuOpen,
      isDeactivatedOrg = _ref2.isDeactivatedOrg,
      leftMenu = _ref2.leftMenu,
      menu = _ref2.menu,
      navbarRef = _ref2.navbarRef,
      program = _ref2.program,
      renderImpersonationBanner = _ref2.renderImpersonationBanner,
      renderDeactivatedOrgBanner = _ref2.renderDeactivatedOrgBanner,
      rightMenu = _ref2.rightMenu,
      setMobileMenuOpen = _ref2.setMobileMenuOpen;

  var getContentLibrarySearchUrl = function getContentLibrarySearchUrl() {
    var programSlug = program === null || program === void 0 ? void 0 : program.slug;
    var learnerDashboardPath = '/student/dashboard';
    var personalizedDashboardPath = '/student/personalized_dashboard';
    var trueLearnerDashboardPath = '/student/learner_dashboard';

    if (![learnerDashboardPath, personalizedDashboardPath, trueLearnerDashboardPath].some(function (path) {
      return currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.includes(path);
    }) || !programSlug) {
      return null;
    }

    var url = currentUrl.replace(personalizedDashboardPath, learnerDashboardPath, trueLearnerDashboardPath);
    return "".concat(url.slice(0, url.indexOf(learnerDashboardPath)), "/student/dashboard/").concat(programSlug, "/content_library");
  };

  var className = _formatClassName(['clearfix custom-header d-md-flex flex-md-column', {
    impersonating: isImpersonating
  }, {
    deactivated: isDeactivatedOrg
  }, {
    'border-branded': isLearner()
  }]);

  var navbarClassNames = _formatClassName(['custom-content-navbar align-items-md-center d-md-flex', {
    'navbar-collapse': isMobile
  }, {
    'navbar-hide': !isDashiFi && !hasColors
  }]);

  var foundryMenuClassNames = _formatClassName(['header-item foundry-menu float-md-end', {
    'd-flex align-items-center': !!content
  }]);

  var navbarItems = [leftMenu({
    key: 'leftMenu'
  }), !!((_navbarRef$current = navbarRef.current) !== null && _navbarRef$current !== void 0 && _navbarRef$current.childElementCount) && createMenuToggle({
    className: 'bg-transparent mt-0',
    'aria-expanded': String(isMobileMenuOpen),
    'aria-controls': 'navbar',
    onClick: function onClick() {
      return setMobileMenuOpen(function (open) {
        return !open;
      });
    },
    key: 'menuToggle'
  })];

  var getContext = function getContext() {
    var context = '';

    if (currentUrl) {
      var urlObject = new URL(currentUrl);

      if (urlObject.hostname.includes('compliance')) {
        context = 'compliance';
      }
    }

    return context;
  };

  return /*#__PURE__*/React.createElement(ChakraUIProvider, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(getFoundryClass(), " ").concat(getContext(), " learner-header")
  }, /*#__PURE__*/React.createElement("header", {
    id: "header",
    className: className,
    "data-ma-theme": "blue",
    "data-testid": "header"
  }, isImpersonating && renderImpersonationBanner(), isDeactivatedOrg && renderDeactivatedOrgBanner(), /*#__PURE__*/React.createElement("div", {
    className: "foundry-header-container d-md-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between"
  }, navbarItems), /*#__PURE__*/React.createElement("div", {
    className: foundryMenuClassNames
  }, /*#__PURE__*/React.createElement(Collapse, {
    "in": isMobileMenuOpen
  }, /*#__PURE__*/React.createElement("div", {
    id: "navbar",
    className: navbarClassNames,
    "aria-expanded": "".concat(isMobileMenuOpen),
    ref: navbarRef,
    "data-attribute": "navbar"
  }, rightMenu({
    contentLibrarySearch: getContentLibrarySearchUrl()
  }))), menu)))));
};

createLearnerHeader.displayName = "createLearnerHeader";

var createDefaultHeader = function createDefaultHeader(_ref3) {
  var content = _ref3.content,
      customRight = _ref3.customRight,
      getFoundryClass = _ref3.getFoundryClass,
      isCustom = _ref3.isCustom,
      isImpersonating = _ref3.isImpersonating,
      isLearner = _ref3.isLearner,
      isMobile = _ref3.isMobile,
      isNextAdmin = _ref3.isNextAdmin,
      isDeactivatedOrg = _ref3.isDeactivatedOrg,
      leftMenu = _ref3.leftMenu,
      menu = _ref3.menu,
      renderImpersonationBanner = _ref3.renderImpersonationBanner,
      renderDeactivatedOrgBanner = _ref3.renderDeactivatedOrgBanner,
      rightMenu = _ref3.rightMenu;

  var className = _formatClassName(['clearfix', {
    impersonating: isImpersonating
  }, {
    deactivated: isDeactivatedOrg
  }, {
    'border-branded': isLearner()
  }, {
    'custom-header': isCustom
  }]);

  return /*#__PURE__*/React.createElement(ChakraUIProvider, null, /*#__PURE__*/React.createElement("div", {
    className: getFoundryClass()
  }, /*#__PURE__*/React.createElement("header", {
    id: "header",
    className: className,
    "data-ma-theme": "blue",
    "data-testid": "header"
  }, isImpersonating && renderImpersonationBanner(), isDeactivatedOrg && renderDeactivatedOrgBanner(), /*#__PURE__*/React.createElement("div", {
    className: "foundry-header-container"
  }, leftMenu(), isNextAdmin && /*#__PURE__*/React.createElement("div", {
    className: "header-item navbar-search",
    "data-testid": "navbar-search"
  }, /*#__PURE__*/React.createElement("form", {
    role: "search",
    className: "navbar-form-custom",
    action: "/admin/search",
    acceptCharset: "UTF-8",
    method: "get"
  }, /*#__PURE__*/React.createElement("input", {
    name: "utf8",
    type: "hidden",
    value: "\u2713",
    autoComplete: "off"
  }), /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "magnifying-glass"
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: "terms",
    id: "terms",
    placeholder: "Search...",
    className: "form-control top-search-input",
    autoComplete: "off"
  })))), !!customRight && createMenuToggle({
    'data-toggle': 'collapse',
    'data-target': '#navbar',
    'aria-expanded': 'false',
    'aria-controls': 'navbar'
  }), /*#__PURE__*/React.createElement("div", {
    className: "header-item foundry-menu"
  }, !!customRight && isMobile && /*#__PURE__*/React.createElement("div", {
    id: "navbar",
    className: "navbar-collapse custom-content-navbar",
    "aria-expanded": "false"
  }, rightMenu()), !!customRight && !isMobile && /*#__PURE__*/React.createElement("div", {
    id: "navbar",
    className: "customn-content-navbar"
  }, rightMenu()), !customRight && !content && rightMenu(), menu)))));
};

createDefaultHeader.displayName = "createDefaultHeader";
/**
 * Checks if an object with no properties
 * @param {*} object
 * @returns {boolean}
 */

var isObjectWithNoProperties = function isObjectWithNoProperties(object) {
  return _typeof(object) === 'object' && object !== null && Object.keys(object).length === 0;
};

export { createDefaultHeader, createLearnerHeader, isObjectWithNoProperties };